import { Divider, Paper } from '@mui/material';
import { DocumentsContext, IExtendedDocument } from 'Context/DocumentsContext';
import { useContext } from 'react';
import { Title } from './Title';
import { Information } from './Information';
import { DownloadDocument } from './DownloadDocument';
import { IsNew } from '../AccordionDocument/DocumentDetail/IsNew';

export const MobileViewDocuments = () => {
  const { documents, filter } = useContext(DocumentsContext);

  const documentsResults = filter.orderByDescending
    ? documents.previousYearsResults
    : documents.previousYearsResults.reverse();

  const filteredBySubject =
    filter.subjectsTypes.length > 0
      ? documentsResults.filter(
          (doc: IExtendedDocument) =>
            doc.documentSubject &&
            filter.subjectsTypes.includes(doc.documentSubject)
        )
      : documentsResults;

  const filteredByName =
    filter.searchByNameOrSubject.length > 0
      ? filteredBySubject.filter(
          (doc: IExtendedDocument) =>
            doc.name?.includes(filter.searchByNameOrSubject) ||
            doc.subjectName?.includes(filter.searchByNameOrSubject)
        )
      : filteredBySubject;

  return (
    <>
      {filteredByName.map((result: IExtendedDocument, index: number) => {
        return (
          <Paper
            key={index}
            sx={{
              position: 'relative',
              p: '16px 16px 40px 16px',
              border: '1px solid #E7EDFF',
              borderRadius: '16px',
              boxShadow: 'none',
            }}
          >
            <IsNew docDate={result.documentDate} />
            <Title docName={result.name} />
            <Divider sx={{ borderColor: '#E7EDFF', m: '12px 0' }} />
            <Information
              docSubject={result.documentSubject}
              docDate={result.documentDate}
            />
            <DownloadDocument
              docId={result.id}
              docType={result.typeId}
              docName={result.name}
            />
          </Paper>
        );
      })}
    </>
  );
};
